module.exports = __webpack_public_path__ + "img/flyer-icon-8.d60ecdf0.svg";